import n from './node_modules/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = ".mds-highlighted-match {\n  font-weight: var(--size-font-weight-strong);\n  color: unset;\n  background: unset;\n}\n";
n(css,{"container":"body","singleTag":true,"prepend":true,"attributes":{"id":"@magnetic/highlighted-match"}});

export { css, css as default };
//# sourceMappingURL=styles.css.js.map
